/* AGO product page: Plausible events (2026-10-22). Loaded by snippets/vv-pdp-events.liquid on
 * /products/ago-film-processor only. Card B of the Paterson tank insert lands here, card A on
 * /pages/welcome-paterson (its own events, "Paterson: ...").
 *
 * Event names carry the detail because custom properties are not on VV's Plausible plan. Each
 * name has a matching custom-event goal in Plausible. Filter the dashboard by
 * UTM content = product-page to see only card B visitors.
 *
 *   AGO PDP: visit                     every view
 *   AGO PDP: card scan                 a view that came from the card's QR (utm_source=paterson-insert)
 *   AGO PDP: saw <section>             once per view, a third of the section (or 300px) on screen
 *   AGO PDP: kit including tank        the kit picker set to Including tank
 *   AGO PDP: kit without tank          the kit picker set to Without tank
 *   AGO PDP: add to cart (AGO)         a successful /cart/add containing AGO
 *   AGO PDP: add to cart (add-on)      a successful /cart/add of anything else (add-ons, reels)
 *   AGO PDP: checkout click            a click on a checkout button or link (cart drawer included)
 *   AGO PDP: dealer link               a click to /pages/dealers
 *   AGO PDP: video play                a click on a creator video
 *   AGO PDP: question opened           an FAQ question opened
 */
(function () {
  'use strict';
  if (window.vvPdpEvents) return;
  window.vvPdpEvents = true;

  window.plausible = window.plausible || function () { (window.plausible.q = window.plausible.q || []).push(arguments); };
  var track = function (what, done) {
    try { window.plausible('AGO PDP: ' + what, done ? { callback: done } : undefined); } catch (e) { if (done) done(); }
  };
  var once = {};
  var trackOnce = function (what) { if (!once[what]) { once[what] = true; track(what); } };

  track('visit');
  if (/[?&]utm_source=paterson-insert(&|$)/.test(location.search)) track('card scan');

  /* ── add to cart: the theme posts to /cart/add with fetch; count only 2xx ── */
  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var promise = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url.split('#')[0])) {
          promise.then(function (response) {
            if (!response || !response.ok) return;
            response.clone().json().then(function (data) {
              var items = data && data.items ? data.items : [data];
              var ago = items.some(function (it) { return it && (it.handle === 'ago-film-processor' || it.product_id === 15824895213917); });
              track(ago ? 'add to cart (AGO)' : 'add to cart (add-on)');
            }, function () { track('add to cart (AGO)'); });
          }, function () {});
        }
      } catch (e) { /* never break the theme's own request */ }
      return promise;
    };
  }

  var ready = function (fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); };
  ready(function () {
    /* ── sections reached ── keys from templates/product.ago-film-processor.json */
    var SECTIONS = {
      bought_with_ago: 'bought with AGO',
      blocks_yeKrf7: 'video reviews',
      section_image_with_text_gMzHYF: 'temperature',
      section_image_with_text_BFyzJW: 'no inversions',
      section_image_with_text_UGD6XM: 'less chemistry',
      section_image_with_text_HmdQee: 'Paterson tanks',
      section_image_with_text_X9JByQ: 'own programs',
      section_image_with_text_7idrXD: 'sheet film and prints',
      ago_specs: 'specs',
      '1769177253ecec7fd8': 'awards',
      '1767724118ed7244f8': 'user reviews',
      blocks_cT44Fy: 'in media',
      ago_faq: 'questions'
    };
    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          if (e.intersectionRect.height >= Math.min(300, e.boundingClientRect.height / 3)) {
            trackOnce('saw ' + e.target.getAttribute('data-vv-pdp-reach'));
            seen.unobserve(e.target);
          }
        });
      }, { threshold: [0, 0.15, 0.33, 0.5] });
      Object.keys(SECTIONS).forEach(function (key) {
        var el = document.querySelector('.shopify-section[id$="__' + key + '"]');
        if (!el || !el.offsetHeight) return;
        el.setAttribute('data-vv-pdp-reach', SECTIONS[key]);
        seen.observe(el);
      });
    }

    /* ── kit picker ── */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'options[Choose kit]' || !t.checked) return;
      var v = String(t.value || '').toLowerCase();
      if (v.indexOf('without') > -1) track('kit without tank');
      else if (v.indexOf('including') > -1) track('kit including tank');
    }, true);

    /* ── clicks ── */
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('a[href], button, [role="button"]') : null;
      if (!el) return;
      var href = el.tagName === 'A' ? el.getAttribute('href') || '' : '';
      var name = el.getAttribute('name') || '';
      if (name === 'checkout' || /(^|\/)checkout(s)?(\/|\?|$)/.test(href) || el.closest('[action*="/checkout"]') && el.type === 'submit') {
        track('checkout click');
        return;
      }
      if (/\/pages\/dealers(\?|#|$)/.test(href)) {
        var plain = e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && (!el.target || el.target === '_self');
        if (!plain) { track('dealer link'); return; }
        e.preventDefault();
        var went = false;
        var go = function () { if (!went) { went = true; window.location.href = el.href; } };
        track('dealer link', go);
        setTimeout(go, 400);
        return;
      }
      if (/ai-video-section__facade|vvv__play|video__facade/.test(String(el.className || ''))) { track('video play'); return; }
      if (/ago-faq__btn/.test(String(el.className || ''))) {
        setTimeout(function () { if (el.getAttribute('aria-expanded') === 'true') track('question opened'); }, 0);
      }
    }, true);
  });
})();
